<template>
  <div
    class="the-footer shadow-md transition-transform h-10 w-full"
    testek="the-footer"
  >
    <div class="flex justify-between items-center pl-5 pr-5 h-full">
      <div class="text-base">Copyright @2024 - Testek</div>
      <div class="flex items-center">
        <div class="text-base flex items-center">
          {{ $t("i18nCommon.TestekTitleDashboard") }}
        </div>
        <div class="ml-1 mr-1 text-base flex items-center">-</div>
        <div class="text-src/i18n/vi/i18nCommon.js  flex items-center">
          {{ $t("i18nCommon.HotLineZalo") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheFooter",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.the-footer {
  border-top: 1px solid #e8e8e8;
  background: #fff;
  z-index: 1000;
}
</style>
